import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    logoUrl: ''
  },
  mutations: {
    SET_LOGOURL: (state, payload) => {
      state.logoUrl = payload
    }
  },
  getters: {
    logoUrl: state => state.app.logoUrl
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js